import * as angular from 'angular';

(function () {
    'use strict';

    angular
        .module('app')
        .directive('lotSizeGreaterThanZero', lotSizeGreaterThanZero);

    /**
     * Validate minimum lot runtime
     *
     * @author bjnowak.btc
     * @ngInject
     */
    function lotSizeGreaterThanZero() {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function (scope, element, attr, ctrl) {
                ctrl.$validators.lotSizeGreaterThanZero = function (
                    modelValue,
                    viewValue
                ) {
                    if (scope.disableValidator) {
                        return true;
                    }
                    return (modelValue || viewValue) > 0;
                };

                scope.$watchGroup(
                    [
                        'selectLotUnit',
                        'proposalRuntime.start',
                        'proposalRuntime.end'
                    ],
                    function () {
                        ctrl.$validate();
                        ctrl.$setDirty();
                    }
                );
            }
        };
    }
})();
